// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"GroupScreen_nameCell__2ny0z"};